import { ChallengeCriteriaType } from './ChallengeCriteria';

export const CHALLENGE_CRITERIAS: ChallengeCriteriaType[] = [
    { percent: 30, text: 'Оригинальность идеи проекта', icon: 'thinking' },
    { percent: 30, text: 'Визуальная составляющая', icon: 'picture' },
    { percent: 40, text: 'Мастерство использования нейросетей', icon: 'stars' },
];
